<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    农林站<br>
站点介绍<br>
农林站位于农林路和红荔西路交叉路口东侧。东南侧室东海购物广场及东海文化广场，南面为深南中学小区、农林绿洲办公楼，西侧是市三建公司家属住宅小区，东北侧室深圳市荔轩小学及农科中心综合楼，北面为荔香花园小区，西北侧为竹园小学及香山美树苑小区。农林站装修设计采用绿色色彩基调。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:39	23:38	7号线	3分35秒	5分55秒<br>
太安	06:04	23:19	7号线	3分35秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:33	23:38	7号线	4分钟	5分55秒<br>
太安	06:11	23:19	7号线	4分钟	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:33	00:38	7号线	4分钟	5分55秒<br>
太安	06:11	00:19	7号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A出入口:<br>
深圳高级中学南校区、福田区风湿病专科医院、农林路（南）、深南中学小区、竹园小区、鑫竹苑、建业小区<br><br>
B出入口:<br>
农科商务办公楼、农轩路（南侧）、红荔西路（南侧）<br><br>
C出入口:<br>
农轩路（北侧）、红荔西路（北侧）、荔林苑、香荔花园、龙溪花园、俊安苑、香榭里花园、深圳福田区东海实验小学、深圳高级中学中心校区、香蜜公园<br><br>
D1出入口:<br>
荔翠阁、暨南大学附属深圳眼科医院、农林路（北侧）、深圳福田区教育科学研究院第二附属小学、香山美树苑、风临左岸（修改）、佳泰兴苑、深圳市儿童乐园、天主教圣安多尼堂<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 东海实验小学<br>
108路,B611路，71，B968<br><br>
B出入口:<br>
公交站名： 农科中心总站<br>
1路，M312路<br><br>
C出入口:<br>
公交站名： 东海实验小学<br>
108路,B611路, B729侨城一号广场开往深云村总站<br><br>
D出入口:<br>
公交站名： 农林地铁站<br>
73路,107路,B729路，326路，328路，70路，B611路，M312路，M500，M398<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>